"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { style: { "position": "absolute" } };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { key: 3 };
const _hoisted_6 = { key: 4 };
const _hoisted_7 = { class: "production-box" };
const _hoisted_8 = { key: 5 };
const _hoisted_9 = { key: 6 };
const _hoisted_10 = { key: 7 };
const _hoisted_11 = { key: 8 };
const _hoisted_12 = {
    class: "points points-big",
    style: { "transform": "scale(0.5)", "margin-left": "-16px", "margin-top": "-18px", "height": "80px", "line-height": "80px", "font-size": "72px" }
};
const _hoisted_13 = { key: 9 };
const _hoisted_14 = { key: 10 };
const _hoisted_15 = { key: 11 };
const _hoisted_16 = { key: 12 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.metadata.build.type === _ctx.ColonyBenefit.ADD_RESOURCES_TO_CARD)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (_ctx.metadata.build.quantity[_ctx.idx] === 3)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_1.normalizeClass)(["colony-placement-bonus triple-res resource white-x white-x--3", _ctx.resource])
                    }, null, 2))
                    : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: 1,
                        class: (0, vue_1.normalizeClass)(["resource", _ctx.resource]),
                        style: { "margin-top": "11px" }
                    }, null, 2))
            ]))
            : (_ctx.metadata.build.type === _ctx.ColonyBenefit.COPY_TRADE)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                        (0, vue_1.createElementVNode)("div", { class: "copy-trade-box" }, "Copy Trade", -1)
                    ]))]))
                : (_ctx.metadata.build.type === _ctx.ColonyBenefit.DRAW_CARDS && _ctx.metadata.build.quantity[_ctx.idx] === 2)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                            (0, vue_1.createElementVNode)("div", {
                                class: "resource card card-with-border",
                                style: { "margin-top": "0px", "margin-left": "-5px", "transform": "scale(0.8)" }
                            }, null, -1),
                            (0, vue_1.createElementVNode)("div", {
                                class: "resource card card-with-border",
                                style: { "position": "absolute", "margin": "0 0 0 -30px", "transform": "scale(0.8)" }
                            }, null, -1)
                        ]))]))
                    : (_ctx.metadata.build.type === _ctx.ColonyBenefit.GAIN_INFLUENCE)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                                (0, vue_1.createElementVNode)("div", {
                                    class: "influence",
                                    style: { "margin-top": "5px" }
                                }, null, -1)
                            ]))]))
                        : (_ctx.metadata.build.type === _ctx.ColonyBenefit.GAIN_PRODUCTION)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                                (0, vue_1.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_1.createElementVNode)("div", {
                                        class: (0, vue_1.normalizeClass)(["production", _ctx.resource])
                                    }, (0, vue_1.toDisplayString)(_ctx.buildQuantityText), 3)
                                ])
                            ]))
                            : (_ctx.metadata.build.type === _ctx.ColonyBenefit.GAIN_RESOURCES)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                                        (0, vue_1.createElementVNode)("div", { class: "colony-placement-bonus resource triple-res titanium white-x white-x--3" }, null, -1)
                                    ]))]))
                                : (_ctx.metadata.build.type === _ctx.ColonyBenefit.GAIN_SCIENCE_TAG)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                                            (0, vue_1.createElementVNode)("div", {
                                                class: "tag tag-science",
                                                style: { "transform": "scale(0.8)", "margin-top": "2px", "margin-left": "4px" }
                                            }, null, -1)
                                        ]))]))
                                    : (_ctx.metadata.build.type === _ctx.ColonyBenefit.GAIN_TR)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                                                (0, vue_1.createElementVNode)("div", {
                                                    class: "tile rating",
                                                    style: { "transform": "scale(0.8)", "margin-left": "-1px" }
                                                }, null, -1)
                                            ]))]))
                                        : (_ctx.metadata.build.type === _ctx.ColonyBenefit.GAIN_VP)
                                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_11, [
                                                (0, vue_1.createElementVNode)("div", _hoisted_12, (0, vue_1.toDisplayString)(_ctx.buildQuantityText), 1)
                                            ]))
                                            : (_ctx.metadata.build.type === _ctx.ColonyBenefit.INCREASE_VENUS_SCALE)
                                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
                                                        (0, vue_1.createElementVNode)("div", { class: "tile venus-tile venus-colony-bonus" }, null, -1)
                                                    ]))]))
                                                : (_ctx.metadata.build.type === _ctx.ColonyBenefit.OPPONENT_DISCARD)
                                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                                                            (0, vue_1.createElementVNode)("div", {
                                                                class: "resource card red-outline",
                                                                style: { "margin-left": "5px", "margin-top": "2px", "transform": "scale(0.8)" }
                                                            }, null, -1)
                                                        ]))]))
                                                    : (_ctx.metadata.build.type === _ctx.ColonyBenefit.PLACE_OCEAN_TILE)
                                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_15, [...(_cache[8] || (_cache[8] = [
                                                                (0, vue_1.createElementVNode)("div", { class: "tile ocean-tile ocean-tile-colony" }, null, -1)
                                                            ]))]))
                                                        : (_ctx.metadata.build.type === _ctx.ColonyBenefit.PLACE_HAZARD_TILE)
                                                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_16, [...(_cache[9] || (_cache[9] = [
                                                                    (0, vue_1.createElementVNode)("div", { class: "tile hazard-tile" }, null, -1)
                                                                ]))]))
                                                            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
